import * as Types from '../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
export type CompleteSmartApplyApplicationStateFragment = {
    __typename: 'SmartApplyApplicationState';
    id: string;
    draftId: string;
    contactInfo?:
        | {
              __typename: 'ContactInfoSmartApplyApplicationState';
              firstName?: string | null | undefined;
              lastName?: string | null | undefined;
              firstNamePronunciation?: string | null | undefined;
              lastNamePronunciation?: string | null | undefined;
              email?: any | null | undefined;
              phoneNumber?: string | null | undefined;
              dateOfBirth?: string | null | undefined;
              gender?: string | null | undefined;
              area?: string | null | undefined;
              city?: string | null | undefined;
              country?: string | null | undefined;
              resumeContactInfo?:
                  | {
                        __typename: 'ResumeContactInfo';
                        phone?: string | null | undefined;
                        name?:
                            | {
                                  __typename: 'ResumeContactInfoName';
                                  firstName?: string | null | undefined;
                                  lastName?: string | null | undefined;
                              }
                            | null
                            | undefined;
                        location?:
                            | {
                                  __typename: 'ResumeContactInfoLocation';
                                  city?: string | null | undefined;
                                  country?: string | null | undefined;
                              }
                            | null
                            | undefined;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
    resume?:
        | {
              __typename: 'ResumeSmartApplyApplicationState';
              resumeDetail?:
                  | {
                        __typename: 'ResumeDetailSmartApplyApplicationState';
                        origin: Types.ResumeOriginSmartApplyApplicationState;
                        files: Array<{
                            __typename: 'FilesSmartApplyApplicationState';
                            type: string;
                            uri: any;
                        }>;
                    }
                  | null
                  | undefined;
              tailoredResume?:
                  | {
                        __typename: 'TailoredResumeDetailSmartApplyApplicationState';
                        firstName?: string | null | undefined;
                        lastName?: string | null | undefined;
                        phoneNumber?: string | null | undefined;
                        location?:
                            | {
                                  __typename: 'TailoredResumeLocation';
                                  postalCode?: string | null | undefined;
                                  unknownLocation?: string | null | undefined;
                              }
                            | null
                            | undefined;
                        workExperiences: Array<{
                            __typename: 'TailoredResumeWorkExperience';
                            title?: string | null | undefined;
                            company?: string | null | undefined;
                        }>;
                        educations: Array<{
                            __typename: 'TailoredResumeEducation';
                            school?: string | null | undefined;
                            degree?:
                                | {
                                      __typename: 'TailoredResumeDegree';
                                      degreeName?: string | null | undefined;
                                      field?: string | null | undefined;
                                  }
                                | null
                                | undefined;
                        }>;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
    questionsAndAnswers?:
        | {
              __typename: 'ScreenerQuestionsAndAnswersSmartApplyApplicationState';
              screener: Array<{
                  __typename: 'QuestionAndAnswerSmartApplyApplicationState';
                  questionId: string;
                  answer?:
                      | { __typename: 'FileAnswerSmartApplyApplicationState' }
                      | { __typename: 'HierarchicalAnswerSmartApplyApplicationState' }
                      | { __typename: 'MultiFieldAnswerSmartApplyApplicationState' }
                      | { __typename: 'MultiFileAnswerSmartApplyApplicationState' }
                      | { __typename: 'MultiTextAnswerSmartApplyApplicationState' }
                      | { __typename: 'TextAnswerSmartApplyApplicationState'; value: string }
                      | null
                      | undefined;
              }>;
          }
        | null
        | undefined;
};

export type SmartApplyApplicationStateIdentifiersFragment = {
    __typename: 'SmartApplyApplicationState';
    id: string;
    draftId: string;
};

export type CompleteContactInfoFragment = {
    __typename: 'SmartApplyApplicationState';
    id: string;
    draftId: string;
    contactInfo?:
        | {
              __typename: 'ContactInfoSmartApplyApplicationState';
              firstName?: string | null | undefined;
              lastName?: string | null | undefined;
              firstNamePronunciation?: string | null | undefined;
              lastNamePronunciation?: string | null | undefined;
              email?: any | null | undefined;
              phoneNumber?: string | null | undefined;
              dateOfBirth?: string | null | undefined;
              gender?: string | null | undefined;
              area?: string | null | undefined;
              city?: string | null | undefined;
              country?: string | null | undefined;
              resumeContactInfo?:
                  | {
                        __typename: 'ResumeContactInfo';
                        phone?: string | null | undefined;
                        name?:
                            | {
                                  __typename: 'ResumeContactInfoName';
                                  firstName?: string | null | undefined;
                                  lastName?: string | null | undefined;
                              }
                            | null
                            | undefined;
                        location?:
                            | {
                                  __typename: 'ResumeContactInfoLocation';
                                  city?: string | null | undefined;
                                  country?: string | null | undefined;
                              }
                            | null
                            | undefined;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
};

export type CompleteResumeDataFragment = {
    __typename: 'SmartApplyApplicationState';
    id: string;
    draftId: string;
    resume?:
        | {
              __typename: 'ResumeSmartApplyApplicationState';
              resumeDetail?:
                  | {
                        __typename: 'ResumeDetailSmartApplyApplicationState';
                        origin: Types.ResumeOriginSmartApplyApplicationState;
                        files: Array<{
                            __typename: 'FilesSmartApplyApplicationState';
                            type: string;
                            uri: any;
                        }>;
                    }
                  | null
                  | undefined;
              tailoredResume?:
                  | {
                        __typename: 'TailoredResumeDetailSmartApplyApplicationState';
                        firstName?: string | null | undefined;
                        lastName?: string | null | undefined;
                        phoneNumber?: string | null | undefined;
                        location?:
                            | {
                                  __typename: 'TailoredResumeLocation';
                                  postalCode?: string | null | undefined;
                                  unknownLocation?: string | null | undefined;
                              }
                            | null
                            | undefined;
                        workExperiences: Array<{
                            __typename: 'TailoredResumeWorkExperience';
                            title?: string | null | undefined;
                            company?: string | null | undefined;
                        }>;
                        educations: Array<{
                            __typename: 'TailoredResumeEducation';
                            school?: string | null | undefined;
                            degree?:
                                | {
                                      __typename: 'TailoredResumeDegree';
                                      degreeName?: string | null | undefined;
                                      field?: string | null | undefined;
                                  }
                                | null
                                | undefined;
                        }>;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
};

export type CompleteQuestionsDataFragment = {
    __typename: 'SmartApplyApplicationState';
    id: string;
    draftId: string;
    questionsAndAnswers?:
        | {
              __typename: 'ScreenerQuestionsAndAnswersSmartApplyApplicationState';
              screener: Array<{
                  __typename: 'QuestionAndAnswerSmartApplyApplicationState';
                  questionId: string;
                  answer?:
                      | { __typename: 'FileAnswerSmartApplyApplicationState' }
                      | { __typename: 'HierarchicalAnswerSmartApplyApplicationState' }
                      | { __typename: 'MultiFieldAnswerSmartApplyApplicationState' }
                      | { __typename: 'MultiFileAnswerSmartApplyApplicationState' }
                      | { __typename: 'MultiTextAnswerSmartApplyApplicationState' }
                      | { __typename: 'TextAnswerSmartApplyApplicationState'; value: string }
                      | null
                      | undefined;
              }>;
          }
        | null
        | undefined;
};

export const CompleteSmartApplyApplicationStateFragmentDoc = gql`
    fragment CompleteSmartApplyApplicationState on SmartApplyApplicationState {
        __typename
        id
        draftId
        contactInfo {
            __typename
            firstName
            lastName
            firstNamePronunciation
            lastNamePronunciation
            email
            phoneNumber
            dateOfBirth
            gender
            area
            city
            country
            resumeContactInfo {
                __typename
                name {
                    __typename
                    firstName
                    lastName
                }
                phone
                location {
                    __typename
                    city
                    country
                }
            }
        }
        resume {
            __typename
            resumeDetail {
                __typename
                origin
                files {
                    __typename
                    type
                    uri
                }
            }
            tailoredResume {
                __typename
                firstName
                lastName
                phoneNumber
                location {
                    __typename
                    postalCode
                    unknownLocation
                }
                workExperiences {
                    __typename
                    title
                    company
                }
                educations {
                    __typename
                    degree {
                        __typename
                        degreeName
                        field
                    }
                    school
                }
            }
        }
        questionsAndAnswers {
            __typename
            screener {
                __typename
                questionId
                answer {
                    __typename
                    ... on TextAnswerSmartApplyApplicationState {
                        value
                    }
                }
            }
        }
    }
`;
export const SmartApplyApplicationStateIdentifiersFragmentDoc = gql`
    fragment SmartApplyApplicationStateIdentifiers on SmartApplyApplicationState {
        __typename
        id
        draftId
    }
`;
export const CompleteContactInfoFragmentDoc = gql`
    fragment CompleteContactInfo on SmartApplyApplicationState {
        __typename
        id
        draftId
        contactInfo {
            __typename
            firstName
            lastName
            firstNamePronunciation
            lastNamePronunciation
            email
            phoneNumber
            dateOfBirth
            gender
            area
            city
            country
            resumeContactInfo {
                __typename
                name {
                    __typename
                    firstName
                    lastName
                }
                phone
                location {
                    __typename
                    city
                    country
                }
            }
        }
    }
`;
export const CompleteResumeDataFragmentDoc = gql`
    fragment CompleteResumeData on SmartApplyApplicationState {
        __typename
        id
        draftId
        resume {
            __typename
            resumeDetail {
                __typename
                origin
                files {
                    __typename
                    type
                    uri
                }
            }
            tailoredResume {
                __typename
                firstName
                lastName
                phoneNumber
                location {
                    __typename
                    postalCode
                    unknownLocation
                }
                workExperiences {
                    __typename
                    title
                    company
                }
                educations {
                    __typename
                    degree {
                        __typename
                        degreeName
                        field
                    }
                    school
                }
            }
        }
    }
`;
export const CompleteQuestionsDataFragmentDoc = gql`
    fragment CompleteQuestionsData on SmartApplyApplicationState {
        __typename
        id
        draftId
        questionsAndAnswers {
            __typename
            screener {
                __typename
                questionId
                answer {
                    __typename
                    ... on TextAnswerSmartApplyApplicationState {
                        value
                    }
                }
            }
        }
    }
`;
